import type { RouteState } from './types';

const getDestinationId = (state: RouteState) => state.destinationId;

const getDestinationEntityId = (state: RouteState) => state.destinationEntityId;

const getOriginId = (state: RouteState) => state.originId;

const getOriginEntityId = (state: RouteState) => state.originEntityId;

const getDestinationCityName = (state: RouteState) => state.destinationCityName;

export default {
  getDestinationId,
  getDestinationEntityId,
  getOriginId,
  getOriginEntityId,
  getDestinationCityName,
};
